<template>
    <va-edit-layout>
        <RefundEventOrderFee-form
            :id="id"
            :title="title"
            :item="item"
        ></RefundEventOrderFee-form>
    </va-edit-layout>
</template>

<script>
export default {
    props: ["id", "title", "item"],
};
</script>
